import React, { useContext, useState, useEffect } from 'react'

import withView from 'core/components/withView'
import useFetch from 'core/hooks/use-fetch'

import { GlobalContext } from 'core/contexts/global-context'
import { getPostBackgrounds } from 'core/helpers/wp-data-helpers'

import Window from 'core/components/Window'
import WPArticle from 'core/components/WPArticle'

const About = props => {
  const global = useContext(GlobalContext)
  const [open, setOpen] = useState(true)
  const [missionOpen, setMissionOpen] = useState(true)

  const { loading, error, data } = useFetch('/page/about', {
    onSuccess: data => global.setBackground(getPostBackgrounds(data))
  })

  const close = e => {
    setOpen(false)
  }

  const closeMission = e => {
    setMissionOpen(false)
  }

  useEffect(() => {
    if (!open) setOpen(true)
    if (!missionOpen) setMissionOpen(true)
  }, [props.location.key])

  if (error) return <p>An error happened: {error.message}</p>

  const missionStatement = data ? data.fields.mission_statement_content : ''
  const hasMissionStatement = missionStatement && missionStatement.length > 0

  return (
    <div className={props.className}>
      <Window
        resizable
        open={open}
        loading={loading}
        mobile={global.mobile}
        fullscreen={global.mobile}
        maxWidth={800}
        x="5%"
        y="5%"
        bounds={null}
        titlebar={{
          title: props.title,
          close: global.mobile ? null : close
        }}
      >
        {data && data.post_content && (
          <WPArticle
            content={[
              hasMissionStatement && global.mobile ? `${missionStatement}` : '',
              data.post_content
            ].join('')}
          />
        )}
      </Window>
      {!global.mobile && hasMissionStatement && (
        <Window
          resizable
          open={missionOpen}
          maxWidth={900}
          x="30%"
          y="30%"
          // height="auto"
          // width="auto"
          bounds={null}
          titlebar={{
            title: props.title,
            close: closeMission
          }}
        >
          <WPArticle content={[data.fields.mission_statement_content].join('')}></WPArticle>
        </Window>
      )}
    </div>
  )
}

export default withView(About)
